<!-- 详细页:命盘 -->
<template>
    <div class="layout-detail-fate-box">
        <div class="layout-detail-fate dsp-flex" v-bind:class="'column-fate-' + (fateData.length + (fateSideData ? fateSideData.length : 0))" v-if="!siZhuLiuNianReverse">
            <column-item class="column-bl-white"
                v-for="(data, index) in fateData"
                v-bind:key="'fate' + data.id + Math.random(0, 10)"
                v-bind:ColumnData="data"
                v-bind:columnFateData="fateInfo"
                v-bind:hasSexIcon="(parseInt(settingConfigData.nianyueRishi) == 0 && index == 2) || (parseInt(settingConfigData.nianyueRishi) == 1 && index == 1)"
                v-bind:hasKong="parentFrom != 'mini' && parentFrom != 'contrast'"
                v-bind:nayinStyle="'fate'"
                v-bind:clickFunc="clickItem">
            </column-item>
            <column-item class="column-bl" v-show="!hideSideBar" 
                v-for="data in fateSideData" 
                v-bind:key="'fate-side' + data.id + Math.random(0, 10)"
                v-bind:ColumnData="data"
                v-bind:columnFateData="{}"
                v-bind:hasKong="parentFrom != 'mini' && parentFrom != 'contrast'"
                v-bind:nayinStyle="'fate'"
                v-bind:closeFunc="clickSideClose"
                v-bind:hasClose="true"
                v-bind:showBefore="false">
            </column-item>
        </div>
        <div class="layout-detail-fate dsp-flex" v-bind:class="'column-fate-' + (fateData.length + (fateSideData ? fateSideData.length : 0))" v-if="siZhuLiuNianReverse">
            <column-item class="column-br" v-show="!hideSideBar" 
                v-for="data in fateSideData" 
                v-bind:key="'fate-side' + data.id + Math.random(0, 10)"
                v-bind:ColumnData="data"
                v-bind:columnFateData="{}"
                v-bind:hasKong="parentFrom != 'mini'"
                v-bind:nayinStyle="'fate'"
                v-bind:closeFunc="clickSideClose"
                v-bind:hasClose="true">
            </column-item>
            <column-item class="column-bl-white"
                v-for="(data, index) in fateData"
                v-bind:key="'fate' + data.id + Math.random(0, 10)"
                v-bind:ColumnData="data"
                v-bind:columnFateData="fateInfo"
                v-bind:hasSexIcon="(parseInt(settingConfigData.nianyueRishi) == 0 && index == 2) || (parseInt(settingConfigData.nianyueRishi) == 1 && index == 1)"
                v-bind:hasKong="parentFrom != 'mini'"
                v-bind:nayinStyle="'fate'"
                v-bind:clickFunc="clickItem">
            </column-item>
        </div>
    </div>
</template>

<script>
import ColumnItem from '../../components/ColumnItem.vue'
export default {
    name: 'DetailFate',
    props: [
        'parentFrom',
        'hideSideBar',
        'fateData',
        'fateSideData',
        'fateInfo',
        'siZhuLiuNianReverse',
        'sideCloseFunc',
        'arrowFunc'
    ],
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    components: { ColumnItem },
    methods:{
        clickItem() {
            this.$store.dispatch('setting/toggleSetHideTypes')
        },
        clickSideClose(data) {
            if(typeof(this.sideCloseFunc) == 'function') {
                this.sideCloseFunc(data);
            }
            this.$bus.emit('resetFortune')
        }
    }
}
</script>